import $ from 'jquery';
import SubmitModalFlow from '../../components/SubmitModalFlow/SubmitModalFlow';
import EditChecker from '../../components/EditChecker/EditChecker';
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { getReviewTabElements, getAdditionalCarrierMap, getMap } from './elementsbindMap';

export default function ReviewTab(wizard) {

    const self = this;
    const wizardEl = wizard.getWizardElement();
    const isEdit = wizardEl.data("edit-flag");
    const isDup = wizardEl.data("dup-flag");
    const els = {};
    const elsDetails = {};
    const additionalCarrier = {};

    const reviewTabElements = getReviewTabElements();
    const detailsTabElements = getMap();
    const additionalCarrierMap = getAdditionalCarrierMap();

    let orderTypeObj = {};

    init();

    function init() {
        setElements();
        bindElements();
    }

    self.didNavigateToForm = function () {
        //Functions To Fill Up the review Tab
        orderTypeObj = prepareDataForSubmit();
        fillDetailsSection();
        fillCarrierSection();
        fillOrderPackingSection();
        fillOrderDocumentSection();
    };

    function fillOrderDocumentSection() {
        if (orderTypeObj.packingSlipCI.includingPackingSlip) {
            els.packageLevelSlipOn.removeClass("hidden");
            els.packageLevelSlipOff.addClass("hidden");
            els.packageLevelSlipTemplate.text(elsDetails.packageSlip.find("option:selected").text());
        } else {
            els.packageLevelSlipOn.addClass("hidden");
            els.packageLevelSlipOff.removeClass("hidden");
        }
        if (orderTypeObj.packingSlipCI.includingCI) {
            els.orderLevelSlipOn.removeClass("hidden");
            els.orderLevelSlipOff.addClass("hidden");
            els.orderLevelSlipTemplate.text(elsDetails.orderSlip.find("option:selected").text());
        } else {
            els.orderLevelSlipOn.addClass("hidden");
            els.orderLevelSlipOff.removeClass("hidden");
        }

        if(orderTypeObj.isForSpecifiedRetailer && !orderTypeObj.dropShip){
            els.includeLabelDiv.removeClass("hidden");
            if (orderTypeObj.includingPackageLabel) {
                els.includeLabelOn.removeClass("hidden");
                els.includeLabelOff.addClass("hidden");
            } else {
                els.includeLabelOn.addClass("hidden");
                els.includeLabelOff.removeClass("hidden");
            }
        }
        else{
            els.includeLabelDiv.addClass("hidden");
        }

        if (orderTypeObj.packingSlipCI.includingCI || orderTypeObj.packingSlipCI.includingPackingSlip) {
            els.customDocSection.removeClass("hidden");
            let customDoc = orderTypeObj.packingSlipCI.customizedDocument;
            els.customDocName.text(customDoc.companyName);
            els.customDocFacilityName.text(elsDetails.facilityAddress.find("option:selected").text());
            els.customDocAddressLine.text(elsDetails.orderTypeFacilityAddrss1.text());
            els.customDocCityState.text(elsDetails.orderTypeFacilityAddrss2.text());
            if(customDoc.phoneNumber){
                els.customDocPhone.text(customDoc.countryCode + " " + customDoc.phoneNumber);
            }
            els.customDocEmail.text(customDoc.contactEmail);
            els.customDocHeader.text(customDoc.customNoteHeader);
            els.customDocBody.text(customDoc.customNoteBody);

        } else {
            els.customDocSection.addClass("hidden");
        }

    }

    function fillDetailsSection() {
        els.orderTypeName.text(orderTypeObj.orderTypeName);
        els.orderTypeCode.text(orderTypeObj.orderTypeCode);
        els.fulfillmentCenter.text(elsDetails.orderTypeFullfillmentCenter.find('option:selected').text());
        if (orderTypeObj.isForSpecifiedRetailer) {
            els.specifiedRetailerSection.removeClass("hidden");
            els.retailerName.text(elsDetails.orderTypeRetailerList.find('option:selected').text());
            if (orderTypeObj.dropShip) {
                els.dropShippingYes.removeClass("hidden");
                els.dropShippingNo.addClass("hidden");
            } else {
                els.dropShippingYes.addClass("hidden");
                els.dropShippingNo.removeClass("hidden");
            }
        } else {
            if (!els.specifiedRetailerSection.hasClass("hidden")) {
                els.specifiedRetailerSection.addClass("hidden");
            }
        }
    }

    function fillCarrierSection() {
        setElementsFromScope(additionalCarrier, additionalCarrierMap, wizardEl);
        els.billMethod.text(elsDetails.orderTypeBillingMethod.find('option:selected').text());
        if (orderTypeObj.billing.isPrepaid) {
            els.nonPrepaidLabels.addClass("hidden");
            els.additionalCarrierSection.addClass("hidden");
        } else {
            els.nonPrepaidLabels.removeClass("hidden");
            els.carrierName.text(orderTypeObj.billing.carriers[0].carrierName);
            els.accountNumber.text(orderTypeObj.billing.carriers[0].accountNumber);
            if (orderTypeObj.billing.carriers[0].carrierName == "FedEx") {
                els.nonFedExSection.addClass("hidden");
            } else {
                //For UPS
                let billToAddress = orderTypeObj.billing.carriers[0].billToAddress;
                els.nonFedExSection.removeClass("hidden");
                els.billToName.text(billToAddress.addressName);
                els.billToAddressLine.text(billToAddress.addressLine1 + " " + billToAddress.addressLine2);
                els.cityStatePostalCode.text(billToAddress.city + ", " + billToAddress.state + ", " + billToAddress.postalCode);
                els.billToCountry.text(elsDetails.orderTypeDetailCountry.find('option:selected').text());
            }
            if (!additionalCarrier.additionalCarrierMainDiv.hasClass("hidden") && (additionalCarrier.additionalCarrierMainDiv.length > 0)) {
                els.additionalCarrierSection.removeClass("hidden");
                let index = 0;
                if (orderTypeObj.billing.carriers.length > 1) {
                    index = 1;
                }
                els.additionalCarrierName.text(orderTypeObj.billing.carriers[index].carrierName);
                els.additionalCarrierAccountNumber.text(orderTypeObj.billing.carriers[index].accountNumber);
                if (orderTypeObj.billing.carriers[index].carrierName == "FedEx") {
                    els.additionalNonFedEx.addClass("hidden");
                } else {
                    //For UPS
                    let additionalBillToAddress = orderTypeObj.billing.carriers[index].billToAddress;
                    els.additionalNonFedEx.removeClass("hidden");
                    els.additonalBillToName.text(additionalBillToAddress.addressName);
                    els.additionalBillToAddressLine.text(additionalBillToAddress.addressLine1 + " " + additionalBillToAddress.addressLine2);
                    els.additionalCityStatePostalCode.text(additionalBillToAddress.city + ", " + additionalBillToAddress.state + ", " + additionalBillToAddress.postalCode);
                    els.additionalBillToCountry.text(additionalCarrier.additionalCarrierCountry.find('option:selected').text());
                }
            } else {
                els.additionalCarrierSection.addClass("hidden");
            }
        }
    }

    function fillOrderPackingSection() {
        els.boxType.text(elsDetails.orderTypeBoxType.find('option:selected').text());
        els.boxTypeCost.text(elsDetails.boxTypeDesc.text());
        els.tissuePaper.text(elsDetails.orderTypeTissuePaper.find('option:selected').text());
        els.tissuePaperCost.text(elsDetails.tissuePaperDesc.text());
    }

    function setElements() {
        setElementsFromScope(els, reviewTabElements, wizardEl);
        setElementsFromScope(elsDetails, detailsTabElements, wizardEl);

    }

    function bindElements() {
        //Fucntion For Submit Button
        els.submitBtn.on("click", submitOrderTypeHandler);
        els.sectionTitlesReviewTab.on("click", editPencilClick);
    }

    function editPencilClick(){
        const form = wizardEl.find($(this).data("target-form"));
        wizard.gotToForm(form);
    }

    function submitOrderTypeHandler() {
        const detailsPageUrl = els.submitBtn.data("order-type-details-page-url");
        const saveOrderTypeUrl = els.submitBtn.data("save-order-type-url");
        const submitModalFlow = new SubmitModalFlow({
            confirmModalTitle: "Submitting Order Type",
            confirmModalBody: '<div class="q-pad-all-xl"> Once this order type is submitted and saved to the system, it will be an option to select from when creating orders.</div>',
            confirmModalBtnText: "Submit",
            onConfirmClick: function () {
                let orderTypeObj = prepareDataForSubmit();
                submitModalFlow.showLoadingModal();
                $.ajax({
                    data: {
                        orderType: JSON.stringify(orderTypeObj)
                    },
                    url: saveOrderTypeUrl,
                    dataType: "JSON",
                    type: 'POST',
                    success: function (data) {
                        EditChecker.setPageClean();
                        submitModalFlow.hideAllModals();
                        if (data != null) {
                            submitModalFlow.showSuccessModal();
                            setTimeout(function () {
                                location.href = detailsPageUrl + "&ortId=" + data;
                            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                        } else {
                            submitModalFlow.showFailureModal();
                        }
                    },
                    error: function () {
                        submitModalFlow.hideAllModals();
                        submitModalFlow.showFailureModal();
                    }
                });
            }
        });
        submitModalFlow.init();
        submitModalFlow.showConfirmModal();
    }

    function prepareDataForSubmit() {
        setElementsFromScope(additionalCarrier, additionalCarrierMap, wizardEl);
        let orderTypeObj = {};
        let billToAddressId;
        let boxTypeOpcId;
        orderTypeObj.orderTypeName = elsDetails.orderTypeNameInput.val();
        orderTypeObj.orderTypeCode = elsDetails.orderTypeCodeInput.val();
        if(isEdit && !isDup){
            let orderType = wizardEl.data("edit-order-type-data");
            orderTypeObj.isEdit = true;
            orderTypeObj.ortStatus = orderType.status;
            orderTypeObj.customOrderTypeId = orderType.customOrderTypeId;
            if(orderType.billing.carriers.length >0){
                orderTypeObj.carrierId= orderType.billing.carriers[0].id;
                if (elsDetails.orderTypeCarrier.val() != "FedEx" && orderType.billing.carriers[0].billToAddress) { //carrierName
                    billToAddressId = orderType.billing.carriers[0].billToAddress.id;
                }
            }             
             orderTypeObj.boxTypeOpcId = orderType.boxTypeOpcId;          
        }else{
            orderTypeObj.isEdit = false;
        }
        if (elsDetails.orderTypeRetailerSwitch.is(":checked")) {
            orderTypeObj.retailerName = elsDetails.orderTypeRetailerList.val();
            if (elsDetails.orderTypeDropShipSwitch.is(":checked")) {
                orderTypeObj.dropShip = true;
            } else {
                orderTypeObj.dropShip = false;
            }
            orderTypeObj.isForSpecifiedRetailer = true;
        } else {
            orderTypeObj.isForSpecifiedRetailer = false;
        }
        orderTypeObj.fulfillmentCenter = elsDetails.orderTypeFullfillmentCenter.val();
        

        if(orderTypeObj.isForSpecifiedRetailer && !orderTypeObj.dropShip){
            if (elsDetails.includePackageLabel.is(":checked")) {
                orderTypeObj.includingPackageLabel = true;
            } else {
                orderTypeObj.includingPackageLabel = false;
            }
        }
        orderTypeObj.boxType = elsDetails.orderTypeBoxType.val();
        //orderTypeObj.boxTypeOpcId = boxTypeOpcId;
        orderTypeObj.tissuePaper = elsDetails.orderTypeTissuePaper.val();
        let billing = {};
        billing.billingMethod = elsDetails.orderTypeBillingMethod.val();
        let carriersArray = [];
        if (billing.billingMethod != "Prepaid") {
            //For Main Carrier
            billing.isPrepaid = false;
            let carrierObj = {};
            carrierObj.carrierName = elsDetails.orderTypeCarrier.val();
            carrierObj.accountNumber = elsDetails.orderTypeFedexAccountNumber.val();
            carrierObj.id = orderTypeObj.carrierId;
            if (carrierObj.carrierName != "FedEx") {
                carrierObj.accountNumber = elsDetails.orderTypeUpsAccountNumber.val();
                let billAddress = {};
                billAddress.addressName = elsDetails.orderTypeBillto.val();
                billAddress.addressLine1 = elsDetails.orderTypeDetailAddress.val();
                billAddress.addressLine2 = elsDetails.orderTypeDetailAddress2.val();
                billAddress.city = elsDetails.orderTypeDetailCity.val();
                billAddress.postalCode = elsDetails.orderTypeDetailPostalcode.val();
                billAddress.country = elsDetails.orderTypeDetailCountry.val();
                billAddress.state = elsDetails.orderTypeDetailState.val();
                billAddress.id = billToAddressId;
                if (billAddress.country != "US") {
                    billAddress.state = elsDetails.orderTypeDetailStateInput.val();
                }
                carrierObj.billToAddress = billAddress;
            }
            carriersArray.push(carrierObj);
            if (!additionalCarrier.additionalCarrierMainDiv.hasClass("hidden") && (additionalCarrier.additionalCarrierMainDiv.length > 0)) {
                let additionalCarrierObj = {};
                additionalCarrierObj.carrierName = additionalCarrier.additionalCarrierDrop.val();
                additionalCarrierObj.accountNumber = additionalCarrier.additionalCarrierFedexNumber.val();
                if (additionalCarrierObj.carrierName != "FedEx") {
                    additionalCarrierObj.accountNumber = additionalCarrier.additionalCarrierUPSNumber.val();
                    let billAddress = {};
                    billAddress.addressName = additionalCarrier.additionalCarrierBillTo.val();
                    billAddress.addressLine1 = additionalCarrier.additionalCarrierAddress1.val();
                    billAddress.addressLine2 = additionalCarrier.additionalCarrierAddress2.val();
                    billAddress.city = additionalCarrier.additionalCarrierCity.val();
                    billAddress.postalCode = additionalCarrier.additionalCarrierPostalCode.val();
                    billAddress.country = additionalCarrier.additionalCarrierCountry.val();
                    if (billAddress.country != "US") {
                        billAddress.state = additionalCarrier.additionalCarrierDetailStateText.val();
                    }else{
                        billAddress.state = additionalCarrier.additionalCarrierDetailState.val();
                    }
                    additionalCarrierObj.billToAddress = billAddress;
                }
                carriersArray.push(additionalCarrierObj);
            }
            billing.carriers = carriersArray;
        } else {
            billing.isPrepaid = true;
        }
        orderTypeObj.billing = billing;
        let packingSlipCIObj = {};
        packingSlipCIObj.includingPackingSlip = elsDetails.packagePackingSlip.is(":checked");
        if (packingSlipCIObj.includingPackingSlip) {
            packingSlipCIObj.packingSlipTemplate = elsDetails.packageSlip.val();
        }
        packingSlipCIObj.includingCI = elsDetails.orderPackingSlip.is(":checked");
        if (packingSlipCIObj.includingCI) {
            packingSlipCIObj.CITemplate = elsDetails.orderSlip.val();
        }
        if (packingSlipCIObj.includingCI || packingSlipCIObj.includingPackingSlip) {
            let customizedDocumentObj = {};
            customizedDocumentObj.companyName = elsDetails.companyNameInput.val();
            customizedDocumentObj.contactEmail = elsDetails.customDocEmail.val();
            customizedDocumentObj.countryCode = elsDetails.orderTypeCountryCode.val();
            customizedDocumentObj.phoneNumber = elsDetails.customDocPhoneNumber.val();
            customizedDocumentObj.customNoteHeader = elsDetails.customHeader.val();
            customizedDocumentObj.customNoteBody = elsDetails.customBody.val();
            let facilityObj = {};
            facilityObj.facilityName = elsDetails.facilityAddress.val();
            customizedDocumentObj.facility = facilityObj;
            packingSlipCIObj.customizedDocument = customizedDocumentObj;
        }
        orderTypeObj.packingSlipCI = packingSlipCIObj;
        return orderTypeObj;
    }
}


// WEBPACK FOOTER //
// ./src/pages/orderType/reviewTab.js